import React from 'react';
import { useTheme } from '@/contexts/ThemeContext';
import { cn } from '@/lib/utils';

interface CustomLoaderProps {
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

const CustomLoader: React.FC<CustomLoaderProps> = ({ size = 'md', className = "" }) => {
  const { resolvedTheme } = useTheme();
  
  const sizeClasses = {
    sm: 'h-8 w-8',
    md: 'h-12 w-12',
    lg: 'h-16 w-16'
  };
  
  const logoSrc = resolvedTheme === 'dark' 
    ? "/lovable-uploads/0478f0f4-6d1c-4e90-b08a-6bc2b74cd16c.png" // Dark theme E logo
    : "/lovable-uploads/565cc476-7467-44f1-842d-4aa29cf60319.png"; // Light theme E logo

  return (
    <div className={cn("flex items-center justify-center", className)}>
      <img 
        src={logoSrc}
        alt="Loading..." 
        className={cn(sizeClasses[size], "object-contain animate-logo-pulse")}
      />
    </div>
  );
};

export default CustomLoader;
